var irreducible = require('./irreducible');
var isObject = require('./isObject');

module.exports = irreducible('Object', isObject);



//////////////////
// WEBPACK FOOTER
// ./~/tcomb/lib/Object.js
// module id = 1046
// module chunks = 0